import React from 'react';

const getTimeAgo = (dateStr) => {
  if (!dateStr) return 'Now Playing';
  const trackDate = new Date(dateStr + ' UTC');
  const now = new Date();
  const diffMs = now - trackDate;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMs < 0) return dateStr;
  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 2) return `${diffDays}d ago`;
  return dateStr;
};

const RecentTracksList = ({ tracks }) => {
  if (!tracks || tracks.length === 0) return null;

  return (
    <div className="list-none">
      <h1><span style={{ color: 'var(--accent)' }}>04</span>&nbsp;&nbsp;Recent Tracks</h1>
      <ol>
        {tracks.map((track, index) => (
          <li key={index}>
            <div className="last-track-list">
              {track.image && track.image.length > 0 && (
                <img src={track.image[track.image.length - 1]['#text']} alt={track.name} />
              )}
              <span className="last-track-info">
                <span className="last-track-title">{track.name}</span>
                <span className="last-track-artist">{track.artist['#text']}</span>
              </span>
              <span className="last-track-time">
                {track.date ? getTimeAgo(track.date['#text']) : 'Now'}
              </span>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default RecentTracksList;
